import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import {
  FormGroup,
  FormControl,
  ValidatorFn,
  NgForm,
  ReactiveFormsModule,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ModalPromptComponent } from "../../../../_helpers/Modals/prompt/modal.prompt";
import { Constants } from "../../../../_utils/Constants";
import { APILoginService } from "../../_services/login/API-login";
import { APIEntityService } from "../../_services/entity/API-entity";
import { VoiceService } from "../../_services/voice/voice";
import { LoginComponent } from "../login/login.component";
import { $ModalManagerService } from "../../../../_helpers/Modals/ModalManager.service";
import { $DBManagerService } from "../../../../_helpers/DB/DBManager.service";
import * as crypto from "crypto-js";
import { $BroadcastManagerService } from "../../../../_helpers/BroadcastManager.service";
import { APIConstants } from "../../../../_config/restapis";
import { formatDate } from "@angular/common";
import { MustMatch } from "../../../../_helpers/must-match-validator";

import * as CryptoJS from "crypto-js";
import { Observable } from "rxjs/Observable";
import { ModalPromptEntityComponent } from "../../../../_helpers/Modals/prompt-entity/modal.prompt-entity";

export interface headerTypeValues {
  key: string;
  value: string;
}

const now = new Date();
const currentdat = formatDate(now, "yyyy-MM-dd", "en-US", "+0530");

@Component({
  selector: "app-voice-service-header-registration-tm",
  templateUrl: "./voice-service-header-registration-tm.component.html",
  styleUrls: ["./voice-service-header-registration-tm.component.css"],
})
export class VoiceServiceHeaderRegTMComponent implements OnInit {
  email: any;
  mobileno: any;
  // purpose: any;
  response: any;
  // tmId: any;
  // tmname: any;
  voiceserviceheaderForm: FormGroup;
  isValid: boolean = false;
  // dontremove: boolean = false;
  // downloadnow: boolean = false;
  dontremove1: boolean = false;
  downloadnow1: boolean = false;
  // templateIds: Number[] = [];
  // isNumCheckadres1: boolean = false;
  UrnNum: any;
  // hdr_categorydoc: any;
   tm_supportdoc: any;
  // Entity_Ref_No: any;
  tmid: any;
  tmname: any;
  // indCategory: any;
  // industrySector: any;
  // public category: any;
  // photoName: any;
  photoName1: any;
  fileExtension: any;
  fileExtension1: any;
  fileExtensionMessage: any;
  photoContent: any;
  uploader: string[];
  // fileExtensionError: boolean = false;
  // fileSizeError1: boolean = false;
  // fileSizeError2: boolean = false;
  fileExtensionError2: boolean = false;
  file1SizeError1: boolean = false;
  file1SizeError2: boolean = false;
  myfiles: any[] = [];
  // docfiles1: any;
  // docfiles2: any;
  docfiles3: any;
  // document1: any[] = [];
  document2: any[] = [];
  addDocFlag: boolean = false;
  errDoc: boolean = false;
  public modalRef: BsModalRef;
  returnedValue: any;
  cancelbtn: boolean = false;
  // ispedocs: boolean = false;
  // ishdrdocs: boolean = false;
  // ispedocs: boolean = false;
  TMdocs: string;
  file1: string;
  Hdrdocs: string;
  // PEdocs: string;
  

  constructor(
    private fb: FormBuilder,
    private ls: APIEntityService,
    private vs: VoiceService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    
    private router: Router,
    private modalService: BsModalService
  ) {
    this._route.params.subscribe((params) => {
      this.UrnNum = params["urn"];
      this.tmid = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
      this.tmname = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
    });
  }

  // onChangeCategory(category) {
  //   console.log("category :", category);
  //   this.category = category;
  // }

  get f() {
    return this.voiceserviceheaderForm.controls;
  }

  attachmentList: any = [];

  headerType1: headerTypeValues[] = [
    { key: "S", value: "Service" },
    { key: "T", value: "Transactional" },
  ];

  // public callTyp = [
  //   { value: "OBD", viewValue: "OutBound" },
  //   { value: "Auto", viewValue: "Auto Dialler" },
  //   { value: "Robo", viewValue: "Robo" },
  // ];

  // public headerclas = [
  //   { value: "Permanent", viewValue: "Permanent" },
  //   { value: "Temporary", viewValue: "Temporary" },
  // ];

  // public categoryy = [
  //   {
  //     name: "Banking / Insurance / Financial products / credit cards",
  //     value: 1,
  //   },
  //   { name: "Real Estate", value: 2 },
  //   { name: "Education", value: 3 },
  //   { name: "Health", value: 4 },
  //   { name: "Consumer Goods and Automobiles", value: 5 },
  //   { name: "Communication / Broadcasting / Entertainment / IT", value: 6 },
  //   { name: "Tourism and Leisure", value: 7 },
  //   { name: "Food and Beverages", value: 8 },
  // ];

  public act1 = [
    { value: "Accept", viewValue: "Accept" },
    { value: "Reject", viewValue: "Reject" },
    // { value: "Send for Modification To PE", viewValue: "Send for Modification To PE" },
  ];

  ngOnInit() {
    this.voiceserviceheaderForm = this.fb.group({
      urn: [""],
      entity_id: [""],
      entity_name: [""],
      pe_id: [""],
      pe_name: [""],
      // pe_industry_category: [""],
      header_id: [""],
      header_sts: [""],
      // category: [""],
      // industry_sector: [""],
      headerType: [""],
      // calltype: [""],
      // industry_type: [""],
      // PE_Docs: [""],
     
      // hdr_categorydoc: [""],
      tm_supportdoc: [""],
      peremarks: [""],
      tmremarks: [
        "",
        [
          Validators.required,
          Validators.maxLength(1000),
          Validators.minLength(5),
          Validators.pattern("^(?! ).*(?<! )$"),
        ],
      ],
      purpose: [""],
      businessCtgry: [''],
      action: [""],
    });
   
    this.voiceserviceheaderForm.controls["urn"].setValue(this.UrnNum);
    this.voiceserviceheaderForm.controls["entity_id"].setValue(this.tmid);
    this.voiceserviceheaderForm.controls["entity_name"].setValue(this.tmname);
    
    this.getVoiceHeader(this.UrnNum);
  }

  getVoiceHeader(urn) {
    let data = {
      urn: urn,
    };
    var recstat
    let htype
    let ctgry;
    this.vs.getVoiceServiceHeaderRegTM(data).subscribe((r) => {
      if(r.status == "success") {
      this.voiceserviceheaderForm.controls["pe_id"].setValue(r.message.peid);
      this.voiceserviceheaderForm.controls["pe_name"].setValue(r.message.pename);
      this.voiceserviceheaderForm.controls["header_id"].setValue(r.message.cli);

      if(r.message.sts == 'PP')
        recstat = 'Pending With PE'
      else if(r.message.sts == 'PT')
        recstat = 'Pending With TM'
      else if(r.message.sts == 'PO')
        recstat = 'Pending With TSP'
      else if(r.message.sts == 'A')
        recstat = 'Active'
      else if(r.message.sts == 'R')
        recstat = 'Rejected'
      else if(r.message.sts == 'F')
        recstat = 'Freepool'
      else if(r.message.sts == 'DP')
        recstat = 'Disabled By PE'
      else if(r.message.sts == 'DT')
        recstat = 'Disabled By TM'
      else if(r.message.sts == 'RP')
        recstat = 'Removed By PE'
      else if(r.message.sts == 'RT')
        recstat = 'Removed By TM'
      else if(r.message.sts == 'DO')
        recstat = 'Disabled BY Operator'
      else if(r.message.sts == 'DAO')
        recstat = 'Deactivated By Operator'
      else if(r.message.sts == 'CT')
        recstat = 'Cancelled By Operator'

      this.voiceserviceheaderForm.controls["header_sts"].setValue(recstat);

      if(r.message.htyp == "S"){
        htype = "Service"
      } else if(r.message.htyp == "T") {
        htype = "Transactional"
      }

      this.voiceserviceheaderForm.controls["headerType"].setValue(htype);
      this.voiceserviceheaderForm.controls["headerType"].disable();
      // this.voiceserviceheaderForm.controls["industry_sector"].setValue(
      //   r.message.IndustrySector
      // );
      // this.voiceserviceheaderForm.controls["pe_industry_category"].setValue(
      //   r.message.Industry
      // );
      // this.voiceserviceheaderForm.controls["pe_industry_category"].disable();
      this.voiceserviceheaderForm.controls["peremarks"].setValue(r.message.PEComments);
      // if (r.message.callType) {
      //   this.voiceserviceheaderForm.controls["calltype"].setValue(r.message.callType);
      //   this.voiceserviceheaderForm.controls["calltype"].disable();
      // }
      
      if (r.message.TMComments) {
        this.voiceserviceheaderForm.controls["tmremarks"].setValue(
          r.message.TMComments
        );
        this.voiceserviceheaderForm.controls["tmremarks"].disable();
      }

      // if (r.message.PurposeByPE) {
        this.voiceserviceheaderForm.controls["purpose"].setValue(r.message.PurposeByPE);
        this.voiceserviceheaderForm.controls["purpose"].disable();
      // }
      if (r.message.Action) {
        this.voiceserviceheaderForm.controls["action"].setValue(r.message.Action);
        this.voiceserviceheaderForm.controls["action"].disable();
      }
      
      if(r.message.HeaderIndustryCtgy == "1")
        ctgry = "Banking / Insurance / Financial products / credit cards";
      else if(r.message.HeaderIndustryCtgy == "2")
        ctgry = "Real Estate";
      else if(r.message.HeaderIndustryCtgy == "3")
        ctgry = "Education";
      else if(r.message.HeaderIndustryCtgy == "4")
        ctgry = "Health";
      else if(r.message.HeaderIndustryCtgy == "5")
        ctgry = "Consumer Goods and Automobiles";
      else if(r.message.HeaderIndustryCtgy == "6")
        ctgry = "Communication / Broadcasting / Entertainment / IT";
      else if(r.message.HeaderIndustryCtgy == "7")
        ctgry = "Tourism and Leisure";
      else if(r.message.HeaderIndustryCtgy == "8")
        ctgry = "Food and Beverages";

    this.voiceserviceheaderForm.controls["businessCtgry"].setValue(ctgry);
    this.voiceserviceheaderForm.controls["businessCtgry"].disable();
      

      // switch (r.message.IndustryType) {
      //   case "P":
      //     this.voiceserviceheaderForm.controls["industry_type"].setValue("Private");
      //     break;
      //   case "G":
      //     this.voiceserviceheaderForm.controls["industry_type"].setValue("Government");
      //     break;
      //   case "S":
      //     this.voiceserviceheaderForm.controls["industry_type"].setValue("SEBI");
      //     break;
      //   case "U":
      //     this.voiceserviceheaderForm.controls["industry_type"].setValue(
      //       "Public Limited Company"
      //     );
      //     break;
      //   case "O":
      //     this.voiceserviceheaderForm.controls["industry_type"].setValue("Others");
      //     break;
      //   default:
      //     this.voiceserviceheaderForm.controls["industry_type"].setValue("");
      //     break;
      // }

      // if (r.message.Hash_HdrCatDocsByPE) {
      //   this.voiceserviceheaderForm.controls["hdr_categorydoc"].disable();
      //   this.docfiles1 = r.message.Hash_HdrCatDocsByPE;
      //   this.photoName = r.message.Hash_HdrCatDocsByPE.substring(
      //     r.message.Hash_HdrCatDocsByPE.indexOf(".") + 1
      //   );
      //   console.log("---------------photoName-------", this.photoName);
      // } else {
      //   this.dontremove = true;
      //   this.downloadnow = true;
      // }

      if (r.message.Hash_DocsByTM) {
        this.voiceserviceheaderForm.controls["tm_supportdoc"].disable();
        this.docfiles3 = r.message.Hash_DocsByTM;
        this.photoName1 = r.message.Hash_DocsByTM.substring(
          r.message.Hash_DocsByTM.indexOf(".") + 1
        );
        console.log("---------------photoName--1-----", this.photoName1);
      } else {
        this.dontremove1 = true;
        this.downloadnow1 = true;
      }

      if (
        r.message.sts !== "PT" ||
        (r.message.sts === "PT" && r.message.TMComments)
      ) {
        this.isValid = true;
        // this.dontremove = true;
        this.dontremove1 = true;
        // this.voiceserviceheaderForm.controls["category"].disable();
        this.voiceserviceheaderForm.controls["headerType"].disable();
        // this.voiceserviceheaderForm.controls["calltype"].disable();
        // this.voiceserviceheaderForm.controls["hdr_categorydoc"].disable();
        // this.voiceserviceheaderForm.controls["pe_supportdoc"].disable();
        this.voiceserviceheaderForm.controls["tmremarks"].disable();
        // this.voiceserviceheaderForm.controls["purpose"].disable();
        this.voiceserviceheaderForm.controls["action"].disable();
        this.cancelbtn = true;
      } else {
        this.isValid = false;
        this.cancelbtn = false;
      }

      // if (r.message.Hash_DocsByPE) {
      //   this.voiceserviceheaderForm.controls["PE_Docs"].setValue(
      //     r.message.Hash_DocsByPE.substring(
      //       r.message.Hash_DocsByPE.indexOf(".") + 1
      //     )         
      //   );
      //   this.PEdocs = r.message.Hash_DocsByPE;
      //   console.log("--------------PEdocs------", this.PEdocs);
      //   this.ispedocs = true;
       
      // }

    } else {
      this.$modal.errorModal({
        title: "Voice Service Header Registration",
        msg: "Error Received while getting voice service header details",
      });
    }
    });
  }

  download(folder) {

    console.log("--------file1--0----", folder)
    if (folder === "TMDOCs") {
      this.file1 = this.docfiles3
      console.log("--------file1--1----", this.file1)
    }
    // if (folder === "PEDocs") {
    //   this.file1 =  this.PEdocs
    //   console.log("--------file1----2--", this.file1)
    // }
    // if (folder === "HdrCatDocs") {
    //   this.file1 = this.docfiles1
    //   console.log("--------file1----3--", this.file1)
    // }

    var data = {
      Ref_No: this.UrnNum,
      Folder: folder,
      FileName:  this.file1 ,
    };
    console.log("---------data-------", data);
    this.vs.downloadFilenow(data).subscribe((r) => {
      this.downloadFile(r,  this.file1 );
      this.$modal.successModal({
        title: " Voice Service Header",
        msg: "File has been downloaded Successfully",
      });
    });
  }

  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }



  // onselectcalltype(event) {
  //   console.log("----------event-------------", event, event.value);
  // }
  onselectaction(event) {
    console.log("----------event-------------", event, event.value);
  }

  // onChangeheaderclass(event) {
  //   console.log("----------event-------------", event, event.value);
  // }

  // setField(event) {
  //   console.log("----------event-------------", event, event.value);
  // }
  resetform() {
   
    console.log("---------------I am in reset--");
    this.voiceserviceheaderForm.controls["tmremarks"].reset();
    // this.voiceserviceheaderForm.controls["category"].reset();
    // this.voiceserviceheaderForm.controls["calltype"].reset();
    // this.voiceserviceheaderForm.controls["headerType"].reset();
    // this.voiceserviceheaderForm.controls["purpose"].reset();
    this.voiceserviceheaderForm.controls["action"].reset();
    // this.voiceserviceheaderForm.controls["hdr_categorydoc"].reset();
    this.voiceserviceheaderForm.controls["tm_supportdoc"].reset();
    // this.document1 = [];
    this.document2 = [];
    // this.docfiles1 = null;
    this.docfiles3 = null;
    // this.fileExtensionError = false;
    this.fileExtensionError2 = false;
    // this.fileSizeError1 = false;
    this.file1SizeError2 = false;
    this.file1SizeError1 = false;
    // this.fileSizeError2 = false;
    
  }

  // resetDoc1() {
  //   this.voiceserviceheaderForm.controls["hdr_categorydoc"].reset();
  //   this.document1 = [];
  //   this.docfiles1 = null;
  //   this.fileExtensionError = false;
  //   this.fileSizeError1 = false;
  //   this.fileSizeError2 = false;
  // }

  resetDoc2() {
    this.voiceserviceheaderForm.controls["tm_supportdoc"].reset();
    this.document2 = [];
    this.docfiles3 = null;
    // this.fileExtensionError = false;
    this.fileExtensionError2 = false;
    this.file1SizeError2 = false;
    this.file1SizeError1 = false;
  }

  // onChangeFileUpload(event) {
  //   this.myfiles = event.target.files;
  //   var file = event.target.files[0];
   
  //   let fileNameArr = file.name.split(".");
  //   if (fileNameArr.length > 2) {
  //     this.$modal.errorModal({
  //       title: "Header Registration",
  //       msg: "Can't upload file with two extension!, please upload again.",
  //     });
  //     this.resetDoc1();
  //   } else {
  //     this.photoName = file.name;
  //     this.docfiles1 = this.document1.push(file);
  //     console.log("---  this.docfiles1--", this.docfiles1);
  //     //console.log("---  this.doc1--", this.document1[0]);
  //     if (file.size > 4242880) {
        
  //       this.fileSizeError1 = true;
  //     } else {
  //       this.fileSizeError1 = false;
  //     }
  //     if (file.size <= 0) {
        
  //       this.fileSizeError2 = true;
  //     } else {
  //       this.fileSizeError2 = false;
  //     }

  //     var allowedExtensions = [
  //       "jpg",
  //       "jpeg",
  //       "png",
  //       "JPG",
  //       "JPEG",
  //       "JFIF",
  //       "BMP",
  //       "SVG",
  //       "pdf",
  //       "PNG",
  //     ];
  //     this.fileExtension = file.name.split(".").pop();

  //     if (this.isInArray(allowedExtensions, this.fileExtension)) {
  //       this.fileExtensionError = false;
  //       this.fileExtensionMessage = "";
  //     } else {
  //       this.$modal.errorModal({
  //         title: 'Wrong Format',
  //         msg: 'Please upload the files in specified format.'
  //     });
  //      // this.fileExtensionMessage = "Please upload the files in specified format.!!";
  //       this.fileExtensionError = true;
  //       this.resetDoc1();
  //     }

  //     if (file) {
  //       this.dontremove = false;
  //       var reader = new FileReader();
  //       reader.onloadend = (e: any) => {
  //         var contents = e.target.result;
  //         this.photoContent = contents;
  //       };
  //       reader.readAsDataURL(file);
  //     } else {
  //       alert("Failed to load file");
  //     }
  //   }

   
  // }

  onChangeFileUpload1(event) {
    this.myfiles = event.target.files;
    var file = event.target.files[0];
   
    let fileNameArr = file.name.split(".");
    if (fileNameArr.length > 2) {
      this.$modal.errorModal({
        title: "Voice Service Header Registration",
        msg: "Can't upload file with two extension!, please upload again.",
      });
      this.resetDoc2();
    } else {
      this.photoName1 = file.name;
      this.docfiles3 = this.document2.push(file);
      console.log("---  this.docfiles3--", this.docfiles3);
      //console.log("---  this.doc1--", this.document2[0]);
      if (file.size > 4242880) {
       
        this.file1SizeError1 = true;
      } else {
        this.file1SizeError1 = false;
      }
      if (file.size <= 0) {
       
        this.file1SizeError2 = true;
      } else {
        this.file1SizeError2 = false;
      }

      var allowedExtensions = [
        "jpg","JPG",
        "jpeg","JPEG",
        "png", "PNG",
        "JFIF",
        "BMP",
        "SVG",
        "pdf", "PDF",      
        "zip","ZIP",
        "doc","docx","DOC","DOCX",
        "XLS","XLSX","xls","xlsx",
        "CSV","csv","MSG","msg"
      ];
      this.fileExtension = file.name.split(".").pop();

      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        this.fileExtensionError2 = false;
        this.fileExtensionMessage = "";
      } else {
        this.$modal.errorModal({
          title: 'Wrong Format',
          msg: 'Please upload the files in specified format.'
      });
       // this.fileExtensionMessage = "Please upload the files in specified format.!!";
        this.fileExtensionError2 = true;
        this.resetDoc2();
      }

      if (file) {
        this.dontremove1 = false;
        var reader1 = new FileReader();
        reader1.onloadend = (e: any) => {
          var content = e.target.result;
          this.photoContent = content;
        };
        reader1.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
    }

  }

  // fileRead(photoNam, fil) {
  //   var allowedExtensions = ["jpg", "pdf"];
  //   this.fileExtension = photoNam.split(".").pop();

  //   if (this.isInArray(allowedExtensions, this.fileExtension)) {
  //     // this.fileExtensionError = false;
  //     this.fileExtensionMessage = "";
  //   } else {
  //     this.fileExtensionMessage = "Please upload the files in specified format.!!";
  //     // this.fileExtensionError = true;
  //   }

  //   if (fil) {
  //     var reader1 = new FileReader();
  //     reader1.onloadend = (e: any) => {
  //       var content = e.target.result;
  //       this.photoContent = content;
  //     };
  //     reader1.readAsDataURL(fil);
  //   } else {
  //     alert("Failed to load file");
  //   }
  // }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  onSubmit() {
    // if(this.voiceserviceheaderForm.get("action").value == "Accept"){
    //   this.voiceserviceheaderForm.controls['tm_supportdoc'].setValidators([Validators.required]);
    // } else {
    //   this.voiceserviceheaderForm.controls['tm_supportdoc'].clearValidators();
    // }
    // this.voiceserviceheaderForm.controls['tm_supportdoc'].updateValueAndValidity();
    // if (this.voiceserviceheaderForm.invalid || this.fileExtensionError || this.fileExtensionError2 ||  this.fileSizeError1 || this.fileSizeError2 || this.file1SizeError1 || this.file1SizeError2) {
      if (this.voiceserviceheaderForm.invalid || this.fileExtensionError2 || this.file1SizeError1 || this.file1SizeError2) {
      //alert("Please fill all the mandatory fields")
      let invalid = [];
      let controls = this.voiceserviceheaderForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      if(invalid.length > 0) {
        console.log("before replacement--------", invalid)
        let tmDoc = invalid.findIndex(x => x == "tm_supportdoc")
        invalid[tmDoc] = "TM Certificate";
        console.log("TMdocu--------",tmDoc, invalid)
        this.$modal.errorModal({
          title: 'Voice Service Header Registration TM',
          msg: 'Please fill all the mandatory fields: ' + invalid
      });
      }
      return;
    }
   
    this.VoiceHeaderReg();
    console.log("-----------Submit-----------");
  }

  VoiceHeaderReg() {
    const voiceserviceheaderForm: FormData = new FormData();
    
    let PE_ID = this.voiceserviceheaderForm.get("pe_id").value;
    let TM_ID = this.voiceserviceheaderForm.get("entity_id").value;
    let Header_ID = this.voiceserviceheaderForm.get("header_id").value;
    // let Industry_Cat = this.voiceserviceheaderForm.get("category").value;
    // let htype = this.voiceserviceheaderForm.get("headerType").value;
    // let calltype = this.voiceserviceheaderForm.get("calltype").value;
    let tmRemarks = this.voiceserviceheaderForm.get("tmremarks").value;
    // let purpose = this.voiceserviceheaderForm.get("purpose").value;
    let action = this.voiceserviceheaderForm.get("action").value;

    voiceserviceheaderForm.append("urn", this.UrnNum);
    voiceserviceheaderForm.append("PE_ID", PE_ID);
    voiceserviceheaderForm.append("TM_ID", TM_ID);
    voiceserviceheaderForm.append("Header_ID", Header_ID);
    // voiceserviceheaderForm.append("Hdr_Industry_Cat", Industry_Cat);
    // voiceserviceheaderForm.append("calltype", calltype);
    // voiceserviceheaderForm.append("htyp", htype);
    // voiceserviceheaderForm.append("Hdr_CatDoc", this.document1[0]);
    voiceserviceheaderForm.append("TM_supportdoc", this.document2[0]);
    voiceserviceheaderForm.append("Remarks", tmRemarks);
    // voiceserviceheaderForm.append("purpose", purpose);
    voiceserviceheaderForm.append("action", action);
    voiceserviceheaderForm.append("requestType", "insert");
    
    this.modalRef = this.modalService.show(ModalPromptComponent);
    this.modalRef.content.modalDataObj = {
      title: "Voice Service Header Registration by TM",
      msg:
        "The header request is being  " +
        action +
        ".Would you like to continue and complete your registration now?",
    };

    this.modalRef.content.onClose.subscribe((result) => {
      this.returnedValue = result;
      //console.log("results", result);

      if (this.returnedValue == true) {
        this.vs
          .newVoiceServiceHeaderRegTM(voiceserviceheaderForm)

          .subscribe((r) => {
            //console.log(r);
            if (r.status == "success") {
              this.$modal.successModal({
                title: "Voice Service Header Registration by TM",
                msg:
                  "Voice Header Registration has been submitted successfully URN-" + this.UrnNum,
              });
              this.isValid = true;
              this.router.navigateByUrl("/voice-service-header-list-tm");
              
            } else {
              if (r.message) {
                this.$modal.errorModal({
                  title: "Voice Service Header Registration by TM",
                  msg: r.message,
                });
              } else {
                this.$modal.errorModal({
                  title: "Voice Service Header Registration by TM",
                  msg: "Error in TM Registration!",
                });
              }
            }
            
          });
      } else {
        this.router.navigateByUrl(
          "/voice-service-header-reg-tm;urn=" + this.UrnNum
        );
      }
    });
  }
}
